import React from 'react'
import { useSelector } from 'react-redux'
import { BLOCKED_COUNTRY_VARIANTS } from 'constants/uiConfig'
import BlockedV1 from './BlockedCountryV1'
import BlockedV2 from './BlockedCountryV2'

const BlockedCountry = (props) => {
  const general = useSelector((s) => s.uiConfig?.general)
  const cfg = general?.blockedCountryVariant ?? BLOCKED_COUNTRY_VARIANTS.V1
  const variant = typeof cfg === 'object' && cfg?.variant ? cfg.variant : cfg
  if (variant === BLOCKED_COUNTRY_VARIANTS.V2) {
    return <BlockedV2 {...props} showModal />
  }
  return <BlockedV1 {...props} showModal />
}

export default BlockedCountry
